import { MutationTree } from 'vuex'
import { CMS, Pagination } from '@one/types'
import { arrayToObject } from '@one/core'
import Vue from 'vue'
import { CmsState } from './types'
import MainConfigurationQuery = CMS.Responses.MainConfigurationQuery
import StaticPageDto = CMS.Responses.StaticPageDto

export const mt = {
  SET_MAIN_PAGE_CONFIGURATION: 'SET_MAIN_PAGE_CONFIGURATION',
  CLEAR_STORE: 'CLEAR_STORE',
  SET_ARTICLES_LIST: 'SET_ARTICLES_LIST',
  SET_ARTICLE: 'SET_ARTICLE',
  SET_ARTICLE_TAGS: 'SET_ARTICLE_TAGS',
  SET_GRID_TEMPLATE: 'SET_GRID_TEMPLATE',
  SET_STATIC_PAGE: 'SET_STATIC_PAGE',
  SET_ACCOUNT_STATIC_PAGES: 'SET_ACCOUNT_STATIC_PAGES',
}

export const mutations: MutationTree<CmsState> = {
  [mt.SET_MAIN_PAGE_CONFIGURATION](
    state: CmsState,
    configuration: MainConfigurationQuery,
  ) {
    state.configuration = configuration
  },
  [mt.SET_ARTICLES_LIST](
    state: CmsState,
    payload: Pagination.Pager<CMS.Responses.ArticleLink>,
  ) {
    Vue.set(state.articles, 'articlesList', payload)
  },
  [mt.SET_ARTICLE](state: CmsState, payload: CMS.Responses.ArticleLink) {
    if (!state.articles.byId) { state.articles.byId = {} }
    Vue.set(state.articles.byId, payload.slug, { ...payload })
  },
  [mt.SET_ARTICLE_TAGS](
    state: CmsState,
    payload: Array<CMS.Articles.Tags.ArticleTag>,
  ) {
    Vue.set(state.articles, 'articleTags', {
      ...arrayToObject(payload, 'name'),
    })
  },
  [mt.SET_STATIC_PAGE](state: CmsState, page: StaticPageDto) {
    Vue.set(state.staticPages, page.slug, page)
  },
  [mt.SET_ACCOUNT_STATIC_PAGES](state: CmsState, items: StaticPageDto[]) {
    items.forEach((page: StaticPageDto) => {
      Vue.set(state.accountStaticPages, page.slug, page)
    })
  },
  [mt.CLEAR_STORE]() {
    // we dont want to clear CMS data
  },
  [mt.SET_GRID_TEMPLATE](
    state: CmsState,
    {
      gridSlot,
      content,
    }: { gridSlot: CMS.Grid.GridSlot; content: CMS.Grid.GridElement },
  ) {
    Vue.set(state.grids, gridSlot, content)
  },
}
export default mutations
